import { render, staticRenderFns } from "./ridersGraph.vue?vue&type=template&id=56f34814&scoped=true"
import script from "./ridersGraph.vue?vue&type=script&lang=js"
export * from "./ridersGraph.vue?vue&type=script&lang=js"
import style0 from "./ridersGraph.vue?vue&type=style&index=0&id=56f34814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f34814",
  null
  
)

export default component.exports